import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Features from "./components/Features";
import Categories from "./components/Categories";
import Popular from "./components/Popular";
import MultiDevice from "./components/MultiDevice";
import Testimonials from "./components/Testimonials";
import Faq from "./components/Faq";
import DownloadCTA from "./components/DownloadCTA";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <Hero />
        <Features />
        <Categories />
        <Popular />
        <MultiDevice />
        <Testimonials />
        <Faq />
        <DownloadCTA />
      </main>
      <Footer />
    </div>
  );
}